/* Stufen-Angebot 24.10.2026 (Gehirn #7254): Auswahl „Wie viele Poster?“ auf der Poster-Produktseite.
   Wahl gilt für die Sitzung (sessionStorage lr-stufe). Ab 2 Postern hält sie die Weiterleitung des Gestalters
   (window.__g9keinWeiter) an und fragt nach dem Warenkorb: gleiches Poster nochmal, mit anderen Angaben gestalten,
   anderes Motiv oder doch weniger. Rabatte rechnet allein Shopify (automatische Rabatte), nie dieses Skript. */
(function () {
  'use strict';
  var D = document, box = D.querySelector('[data-lr-stufen]');
  if (!box) return;
  var KEY = 'lr-stufe', HANDLE = (window.LR9 && LR9.handle) || location.pathname.split('/').pop();
  var SICH = 'lr-g9:' + HANDLE, KOPIE = 'lr-stufe-vorlage:' + HANDLE;
  function lies(k, s) { try { return (s || sessionStorage).getItem(k); } catch (e) { return null; } }
  function schreib(k, v, s) { try { (s || sessionStorage).setItem(k, v); } catch (e) {} }
  function stufe() { var v = parseInt(lies(KEY), 10); return v >= 1 && v <= 3 ? v : 2; }
  function setze(v) {
    schreib(KEY, String(v));
    var r = box.querySelector('input[value="' + v + '"]'); if (r) r.checked = true;
    window.__g9keinWeiter = v >= 2;
  }
  setze(stufe());
  box.addEventListener('change', function (e) { if (e.target.name === 'lr-stufe') setze(parseInt(e.target.value, 10)); });

  /* Eingaben des Gestalters mitsichern: der Gestalter löscht seine Sicherung nach dem Warenkorb,
     für „mit anderen Angaben gestalten“ brauchen wir sie noch einmal. */
  setInterval(function () { if (stufe() < 2) return; var s = lies(SICH, localStorage); if (s) schreib(KOPIE, s, localStorage); }, 1500);

  function istPoster(it) { return /Poster|Rahmen|Leinwand/i.test(it.variant_title || '') && (it.product_type || '') === 'Customizer'; }
  function korb() { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
  function zaehle(c) { return c.items.reduce(function (n, it) { return n + (istPoster(it) ? it.quantity : 0); }, 0); }
  function zumKorb() { location.href = '/cart'; }

  var offen = false;
  function frage() {
    if (offen) return; offen = true;
    korb().then(function (c) {
      var n = zaehle(c), z = stufe();
      if (n >= z || n === 0) { zumKorb(); return; }
      var letzt = c.items.filter(istPoster)[0];
      var f = D.createElement('div'); f.className = 'lr-stufen-frage'; f.setAttribute('role', 'dialog'); f.setAttribute('aria-modal', 'true');
      f.innerHTML = '<div class="lr-sf__box"><p class="lr-sf__ok">✓ Poster ' + n + ' von ' + z + ' liegt im Warenkorb</p>' +
        '<h3>Jetzt dein ' + (n + 1) + '. Poster</h3><p class="lr-sf__satz">Ab ' + (z === 3 ? '3 Postern 25' : '2 Postern 20') + '&nbsp;% günstiger – auf alle Poster, auch gerahmt.</p>' +
        '<button type="button" class="lr-sf__knopf" data-a="gleich">Gleiches Poster nochmal</button>' +
        '<button type="button" class="lr-sf__knopf lr-sf__knopf--hell" data-a="anders">Mit anderen Namen oder Fotos gestalten</button>' +
        '<a class="lr-sf__knopf lr-sf__knopf--hell" href="/collections/poster" data-a="motiv">Anderes Motiv wählen</a>' +
        '<button type="button" class="lr-sf__weg" data-a="korb">Doch nur ' + n + ' Poster – zum Warenkorb</button></div>';
      D.body.appendChild(f);
      var k = f.querySelector('[data-a="gleich"]'); if (k) k.focus();
      f.addEventListener('click', function (e) {
        var a = e.target.closest('[data-a]'); if (!a) return;
        var was = a.getAttribute('data-a');
        if (was === 'korb') { setze(n); zumKorb(); }
        else if (was === 'gleich' && letzt) {
          a.disabled = true; a.textContent = 'Wird hinzugefügt …';
          fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: letzt.key, quantity: letzt.quantity + 1 }) })
            .then(function () { f.remove(); offen = false; frage(); }, zumKorb);
        }
        else if (was === 'anders') {
          var s = lies(KOPIE, localStorage); if (s) schreib(SICH, s, localStorage);
          location.replace(location.pathname + location.search + '#gestalten'); location.reload();
        }
      });
    }, zumKorb);
  }
  /* Der Gestalter meldet den bestätigten Warenkorb, indem sein Knopf die Klasse „weiterleiten“ bekommt. */
  new MutationObserver(function (ms) {
    if (stufe() < 2) return;
    for (var i = 0; i < ms.length; i++) { var t = ms[i].target; if (t.classList && t.classList.contains('weiterleiten')) { frage(); return; } }
  }).observe(D.body, { subtree: true, attributes: true, attributeFilter: ['class'] });

  var st = D.createElement('style');
  st.textContent = '.lr-stufen-frage{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:flex-end;justify-content:center;background:rgba(42,33,24,.45);padding:0 0 env(safe-area-inset-bottom,0)}' +
    '.lr-sf__box{width:100%;max-width:440px;background:#fff;border-radius:18px 18px 0 0;padding:22px 20px 20px;display:grid;gap:10px;color:#2A2118;font-family:Jost,system-ui,sans-serif}' +
    '@media(min-width:600px){.lr-stufen-frage{align-items:center}.lr-sf__box{border-radius:18px}}' +
    '.lr-sf__ok{margin:0;font-size:13px;font-weight:500;color:#2F6B3F}.lr-sf__box h3{margin:0;font:500 26px/1.1 "Cormorant Garamond",Georgia,serif}' +
    '.lr-sf__satz{margin:0 0 6px;font-size:14px;color:#5B5249}' +
    '.lr-sf__knopf{display:flex;align-items:center;justify-content:center;min-height:52px;border-radius:99px;border:1.5px solid #2A2118;background:#2A2118;color:#fff;font:500 15.5px Jost,system-ui,sans-serif;text-decoration:none;cursor:pointer}' +
    '.lr-sf__knopf--hell{background:#fff;color:#2A2118}.lr-sf__weg{border:0;background:none;padding:10px;font:400 14px Jost,system-ui,sans-serif;color:#5B5249;text-decoration:underline;cursor:pointer}';
  D.head.appendChild(st);
})();
